import { StringUtils } from '../../shared/utils/string-utils';
import { Board, BoardBackend } from './board';

function getNameFromBackend(board?: BoardBackend) {
  if (!board) {
    return undefined;
  }

  if (board?.userBoardConfig) {
    return board.userBoardConfig.preferredName;
  }

  return board?.title;
}

function getName(board?: { userBoardConfig?: { preferredName: string }; title?: string }): string {
  if (!board) {
    return '';
  }

  if (board?.userBoardConfig) {
    return board?.userBoardConfig?.preferredName ?? '';
  } else {
    return board?.title ?? '';
  }
}

function getNameWithoutFirstEmoji(board?: Board | BoardBackend) {
  const boardName = getName(board);

  if (!boardName) {
    return boardName;
  }
  return StringUtils.isEmoji(StringUtils.getFirstChar(boardName)) ? boardName.substring(2).trim() : boardName;
}

function setName(board: Board | BoardBackend, name: string) {
  isPersonal(board) ? (board.userBoardConfig!.preferredName = name) : (board.title = name);
}

function isPersonal(board?: Board | BoardBackend): boolean {
  return !!board?.userBoardConfig;
}

function isRemoved(board?: Board | BoardBackend) {
  if (!board) {
    return false;
  }
  if (!isPersonal(board)) {
    return false;
  }

  return board.userBoardConfig?.isRemoved;
}

export const BoardFuncs = {
  getName,
  isPersonal,
  setName,
  isRemoved,
  getNameFromBackend,
  getNameWithoutFirstEmoji,
};
